import { render } from "./chat_list_item.vue?vue&type=template&id=0623aed7"
import script from "./chat_list_item.js?vue&type=script&lang=js&external"
export * from "./chat_list_item.js?vue&type=script&lang=js&external"

import "./chat_list_item.vue?vue&type=style&index=0&id=0623aed7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__